var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM2CLastCalibrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41407 0C8.87377 0 11.1031 0.98676 12.7276 2.58602L8.48457 6.8291C7.94617 6.3154 7.21687 6 6.41407 6C5.56007 6 4.78937 6.3568 4.24304 6.9295L0 2.68651C1.63248 1.0282 3.90318 0 6.41407 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41407 14C8.07087 14 9.41407 12.6569 9.41407 11C9.41407 9.3431 8.07087 8 6.41407 8C4.75717 8 3.41406 9.3431 3.41406 11C3.41406 12.6569 4.75717 14 6.41407 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2CLastCalibrationIcon);
export default __webpack_public_path__ + "static/media/m2c_last_calibration_icon.d0bfa22808726e3d8205d06e2bfb11bc.svg";
export { ForwardRef as ReactComponent };